const dictionary = {
  angularjs: {
    skillName: "Angularjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Angular", "typescript", "angular.js"],
    versions: [],
    similarTech: ["Reactjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  angular: {
    skillName: "Angularjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Angular", "typescript", "angular.js"],
    versions: [],
    similarTech: ["Reactjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  typescript: {
    skillName: "Angularjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Angular", "typescript", "angular.js"],
    versions: [],
    similarTech: ["Reactjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  "angular.js": {
    skillName: "Angularjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Angular", "typescript", "angular.js"],
    versions: [],
    similarTech: ["Reactjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  reactjs: {
    skillName: "Reactjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["React", "react.js"],
    versions: [],
    similarTech: ["Angularjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  react: {
    skillName: "Reactjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["React", "Reactjs"],
    versions: [],
    similarTech: ["Angularjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  "react.js": {
    skillName: "Reactjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["React", "Reactjs"],
    versions: [],
    similarTech: ["Angularjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  reactjs: {
    skillName: "Reactjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["React", "Reactjs"],
    versions: [],
    similarTech: ["Angularjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  reactredux: {
    skillName: "Reactjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["reactredux", "React redux", "reactjs redux"],
    versions: [],
    similarTech: ["Angularjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  "react redux": {
    skillName: "Reactjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["reactredux", "React redux", "reactjs redux"],
    versions: [],
    similarTech: ["Angularjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  redux: {
    skillName: "Reactjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: [],
    versions: [],
    similarTech: ["Angularjs", "Backbonejs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  backbonejs: {
    skillName: "Backbonejs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Backbone", "backbone.js"],
    versions: [],
    similarTech: ["Angularjs", "Reactjs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  backbone: {
    skillName: "Backbonejs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Backbone", "backbone.js"],
    versions: [],
    similarTech: ["Angularjs", "Reactjs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  "backbone.js": {
    skillName: "Backbonejs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Backbone", "backbone.js"],
    versions: [],
    similarTech: ["Angularjs", "Reactjs", "Knockoutjs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  knockoutjs: {
    skillName: "Knockoutjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["knockout", "knockout.js"],
    versions: [],
    similarTech: ["Angularjs", "Reactjs", "Backbonejs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  knockout: {
    skillName: "Knockoutjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["knockout", "knockout.js"],
    versions: [],
    similarTech: ["Angularjs", "Reactjs", "Backbonejs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  "knockout.js": {
    skillName: "Knockoutjs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["knockout", "knockout.js"],
    versions: [],
    similarTech: ["Angularjs", "Reactjs", "Backbonejs", "vuejs"],
    type: "Framework",
    booleanSynonyms: []
  },
  vuejs: {
    skillName: "vuejs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["vue", "vue.js"],
    versions: [],
    similarTech: ["Angularjs", "Reactjs", "Backbonejs", "Knockoutjs"],
    type: "Framework",
    booleanSynonyms: []
  },
  vue: {
    skillName: "vuejs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["vue", "vue.js"],
    versions: [],
    similarTech: ["Angularjs", "Reactjs", "Backbonejs", "Knockoutjs"],
    type: "Framework",
    booleanSynonyms: []
  },
  "vue.js": {
    skillName: "vuejs",
    explanation: "Client side framework used for web UI Development",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["vue", "vue.js"],
    versions: [],
    similarTech: ["Angularjs", "Reactjs", "Backbonejs", "Knockoutjs"],
    type: "Framework",
    booleanSynonyms: []
  },
  d3js: {
    skillName: "D3JS",
    explanation:
      "Client side framework primarily used for building customized graphical charts",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["D3", "D3.JS"],
    versions: [],
    similarTech: ["Highchartjs"],
    type: "Framework",
    booleanSynonyms: []
  },
  d3: {
    skillName: "D3JS",
    explanation:
      "Client side framework primarily used for building customized graphical charts",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["D3", "D3.JS"],
    versions: [],
    similarTech: ["Highchartjs"],
    type: "Framework",
    booleanSynonyms: []
  },
  "d3.js": {
    skillName: "D3JS",
    explanation:
      "Client side framework primarily used for building customized graphical charts",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["D3", "D3.JS"],
    versions: [],
    similarTech: ["Highchartjs"],
    type: "Framework",
    booleanSynonyms: []
  },
  highchartjs: {
    skillName: "Highchartjs",
    explanation:
      "Client side framework primarily used for building graphical charts",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Highchart", "Highchart.js"],
    versions: [],
    similarTech: ["D3JS"],
    type: "Framework",
    booleanSynonyms: []
  },
  highchart: {
    skillName: "Highchartjs",
    explanation:
      "Client side framework primarily used for building graphical charts",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Highchart", "Highchart.js"],
    versions: [],
    similarTech: ["D3JS"],
    type: "Framework",
    booleanSynonyms: []
  },
  "highchart.js": {
    skillName: "Highchartjs",
    explanation:
      "Client side framework primarily used for building graphical charts",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development",
      "MVC"
    ],
    synonyms: ["Highchart", "Highchart.js"],
    versions: [],
    similarTech: ["D3JS"],
    type: "Framework",
    booleanSynonyms: []
  },
  html: {
    skillName: "HTML",
    explanation: "Hypertext Markup Language,used in UI Development",
    primaryFamily: "User Interface",
    synonyms: ["html", "HTML5", "Bootstrap"],
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    versions: [],
    similarTech: ["HTML5", "HTML4"],
    type: "",
    booleanSynonyms: []
  },
  html5: {
    skillName: "HTML",
    explanation: "Hypertext Markup Language,used in UI Development",
    primaryFamily: "User Interface",
    synonyms: [],
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    versions: [],
    similarTech: ["HTML5", "HTML4"],
    type: "",
    booleanSynonyms: []
  },
  html4: {
    skillName: "HTML",
    explanation: "Hypertext Markup Language,used in UI Development",
    primaryFamily: "User Interface",
    synonyms: [],
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    versions: [],
    similarTech: ["HTML5", "HTML4"],
    type: "",
    booleanSynonyms: []
  },
  css: {
    skillName: "CSS",
    explanation: "Styling used in web design",
    primaryFamily: "HTML",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: ["CSS", "CSS3", "SASS", "LESS"],
    versions: ["CSS3"],
    similarTech: [],
    type: "",
    booleanSynonyms: ["SASS", "LESS"]
  },
  css3: {
    skillName: "CSS",
    explanation: "Styling used in web design",
    primaryFamily: "HTML",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: [],
    versions: ["CSS3"],
    similarTech: [],
    type: "",
    booleanSynonyms: ["SASS", "LESS"]
  },
  "user experience": {
    skillName: "User Experience",
    explanation:
      "This is part of UI and it’s the art of building user friendly interfaces",
    primaryFamily: "User Interface",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  javascript: {
    skillName: "JavaScript",
    explanation: "This is one of the primary languages used in UI Development",
    primaryFamily: "Programming Language",
    secondaryFamily: ["User Interface"],
    synonyms: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    versions: ["JS"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "ui development": {
    skillName: "Gulp",
    explanation:
      "Open-source JavaScript toolkit by Fractal Innovations and the open source community at GitHub",
    primaryFamily:
      "used as a streaming build system in front-end web development",
    secondaryFamily: ["JavaScript"],
    synonyms: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    versions: ["Gulpjs"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "ui/ux development": {
    skillName: "Gulp",
    explanation:
      "Open-source JavaScript toolkit by Fractal Innovations and the open source community at GitHub",
    primaryFamily:
      "used as a streaming build system in front-end web development",
    secondaryFamily: ["JavaScript"],
    synonyms: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    versions: ["Gulpjs"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "frontend development": {
    skillName: "Gulp",
    explanation:
      "Open-source JavaScript toolkit by Fractal Innovations and the open source community at GitHub",
    primaryFamily:
      "used as a streaming build system in front-end web development",
    secondaryFamily: ["JavaScript"],
    synonyms: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    versions: ["Gulpjs"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "client side": {
    skillName: "Gulp",
    explanation:
      "Open-source JavaScript toolkit by Fractal Innovations and the open source community at GitHub",
    primaryFamily:
      "used as a streaming build system in front-end web development",
    secondaryFamily: ["JavaScript"],
    synonyms: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    versions: ["Gulpjs"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "user interface development": {
    skillName: "Gulp",
    explanation:
      "Open-source JavaScript toolkit by Fractal Innovations and the open source community at GitHub",
    primaryFamily:
      "used as a streaming build system in front-end web development",
    secondaryFamily: ["JavaScript"],
    synonyms: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    versions: ["Gulpjs"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  js: {
    skillName: "JavaScript",
    explanation: "This is one of the primary languages used in UI Development",
    primaryFamily: "Programming Language",
    secondaryFamily: ["User Interface"],
    synonyms: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    versions: ["JS"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  ecmascript: {
    skillName: "ECMAscript",
    explanation: "Its a standard for scripting languages",
    primaryFamily: "JavaScript",
    secondaryFamily: [],
    synonyms: ["ES", "Ecma Script"],
    versions: ["ES5", "ES6"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  es: {
    skillName: "ECMAscript",
    explanation: "Its a standard for scripting languages",
    primaryFamily: "JavaScript",
    secondaryFamily: [],
    synonyms: ["ES", "Ecma Script"],
    versions: ["ES5", "ES6"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "ecma script": {
    skillName: "ECMAscript",
    explanation: "Its a standard for scripting languages",
    primaryFamily: "JavaScript",
    secondaryFamily: [],
    synonyms: ["ES", "Ecma Script"],
    versions: ["ES5", "ES6"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  es5: {
    skillName: "ECMAscript",
    explanation: "Its a standard for scripting languages",
    primaryFamily: "JavaScript",
    secondaryFamily: [],
    synonyms: ["ES", "Ecma Script"],
    versions: ["ES5", "ES6"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  es6: {
    skillName: "ECMAscript",
    explanation: "Its a standard for scripting languages",
    primaryFamily: "JavaScript",
    secondaryFamily: [],
    synonyms: ["ES", "Ecma Script"],
    versions: ["ES5", "ES6"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  babel: {
    skillName: "Babel",
    explanation:
      "Transpiler for JavaScript best known for its ability to turn ES6 (the next version of JavaScript) into code that runs in your browser",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "module bundlers": {
    skillName: "Module bundlers",
    explanation: "They manage and load interdependent modules",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["Bundlers"],
    versions: [],
    similarTech: ["Webpack", "Browserify"],
    type: "",
    booleanSynonyms: []
  },
  bundlers: {
    skillName: "Module bundlers",
    explanation: "They manage and load interdependent modules",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["Bundlers"],
    versions: [],
    similarTech: ["Webpack", "Browserify"],
    type: "",
    booleanSynonyms: []
  },
  webpack: {
    skillName: "Webpack",
    explanation: "They manage and load interdependent modules",
    primaryFamily: "Module bundlers",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["Web pack"],
    versions: [],
    similarTech: ["Browserify"],
    type: "",
    booleanSynonyms: []
  },
  "web pack": {
    skillName: "Webpack",
    explanation: "They manage and load interdependent modules",
    primaryFamily: "Module bundlers",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["Web pack"],
    versions: [],
    similarTech: ["Browserify"],
    type: "",
    booleanSynonyms: []
  },
  browserify: {
    skillName: "Browserify",
    explanation: "They manage and load interdependent modules",
    primaryFamily: "Module bundlers",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: [],
    versions: [],
    similarTech: ["Webpack"],
    type: "",
    booleanSynonyms: []
  },
  bootstrap: {
    skillName: "Bootstrap",
    explanation: "It compliments the HTML for building UI interfaces",
    primaryFamily: "User Interface",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: [],
    versions: ["Bootstrap3"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  bootstrap3: {
    skillName: "Bootstrap",
    explanation: "It compliments the HTML for building UI interfaces",
    primaryFamily: "User Interface",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: [],
    versions: ["Bootstrap3"],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  jquery: {
    skillName: "Jquery",
    explanation:
      "jQuery is a cross-platform JavaScript library designed to simplify the client-side scripting of HTML",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Library",
    booleanSynonyms: []
  },
  sass: {
    skillName: "SASS",
    explanation: "Sass is a style sheet language",
    primaryFamily: "CSS",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: [],
    versions: [],
    similarTech: ["CSS", "LESS"],
    type: "",
    booleanSynonyms: []
  },
  less: {
    skillName: "LESS",
    explanation:
      "Less is a dynamic style sheet language that can be compiled into Cascading Style Sheets and run on the client side or server side.",
    primaryFamily: "CSS",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: [],
    versions: [],
    similarTech: ["CSS", "SASS"],
    type: "",
    booleanSynonyms: []
  },
  ajax: {
    skillName: "Ajax",
    explanation:
      "Method of exchanging data with a serve and updating parts of a web page – without reloading the entire pager",
    primaryFamily: "JavaScript",
    synonyms: [],
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  grunt: {
    skillName: "Grunt",
    explanation:
      "Grunt is a JavaScript task runner, a tool used to automatically perform frequent tasks such as minification, compilation, unit testing, and linting.",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["GruntJs"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  gruntjs: {
    skillName: "Grunt",
    explanation:
      "Grunt is a JavaScript task runner, a tool used to automatically perform frequent tasks such as minification, compilation, unit testing, and linting.",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["GruntJs"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  gulp: {
    skillName: "Gulp",
    explanation:
      "Open-source JavaScript toolkit by Fractal Innovations and the open source community at GitHub, used as a streaming build system in front-end web development",
    primaryFamily: ["JavaScript"],
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["Gulpjs"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  gulpjs: {
    skillName: "Gulp",
    explanation:
      "Open-source JavaScript toolkit by Fractal Innovations and the open source community at GitHub, used as a streaming build system in front-end web development",
    primaryFamily: ["JavaScript"],
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["Gulpjs"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  redux: {
    skillName: "Redux",
    explanation:
      "Redux is an open-source JavaScript library designed for managing application state. It is primarily used together with React or Angular for building user interfaces.",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["ReactRedux", "React Redux", "React-Redux"],
    versions: [],
    similarTech: [],
    type: "Library",
    booleanSynonyms: []
  },
  reactredux: {
    skillName: "Redux",
    explanation:
      "Redux is an open-source JavaScript library designed for managing application state. It is primarily used together with React or Angular for building user interfaces.",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["ReactRedux", "React Redux", "React-Redux"],
    versions: [],
    similarTech: [],
    type: "Library",
    booleanSynonyms: []
  },
  "react redux": {
    skillName: "Redux",
    explanation:
      "Redux is an open-source JavaScript library designed for managing application state. It is primarily used together with React or Angular for building user interfaces.",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["ReactRedux", "React Redux", "React-Redux"],
    versions: [],
    similarTech: [],
    type: "Library",
    booleanSynonyms: []
  },
  "react-redux": {
    skillName: "Redux",
    explanation:
      "Redux is an open-source JavaScript library designed for managing application state. It is primarily used together with React or Angular for building user interfaces.",
    primaryFamily: "JavaScript",
    secondaryFamily: [
      "UI Development",
      "UI/UX Development",
      "FrontEnd Development",
      "Client Side",
      "User Interface Development"
    ],
    synonyms: ["ReactRedux", "React Redux", "React-Redux"],
    versions: [],
    similarTech: [],
    type: "Library",
    booleanSynonyms: []
  },
  dreamweaver: {
    skillName: "Dreamweaver",
    explanation:
      "Dreamweaver is a proprietary web development tool developed by Adobe Systems. ",
    primaryFamily: "User Interface",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: ["Dream weaver", "Dream-weaver"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "dream weaver": {
    skillName: "Dreamweaver",
    explanation:
      "Dreamweaver is a proprietary web development tool developed by Adobe Systems. ",
    primaryFamily: "User Interface",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: ["Dream weaver", "Dream-weaver"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "dream-weaver": {
    skillName: "Dreamweaver",
    explanation:
      "Dreamweaver is a proprietary web development tool developed by Adobe Systems. ",
    primaryFamily: "User Interface",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: ["Dream weaver", "Dream-weaver"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "corel draw": {
    skillName: "Corel Draw",
    explanation:
      "CorelDraw is a vector graphics editor developed and marketed by Corel Corporation",
    primaryFamily: "User Interface",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: ["Corel  Draw", "Corel- Draw"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "corel  draw": {
    skillName: "Corel Draw",
    explanation:
      "CorelDraw is a vector graphics editor developed and marketed by Corel Corporation",
    primaryFamily: "User Interface",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: ["Corel  Draw", "Corel- Draw"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "corel- draw": {
    skillName: "Corel Draw",
    explanation:
      "CorelDraw is a vector graphics editor developed and marketed by Corel Corporation",
    primaryFamily: "User Interface",
    secondaryFamily: [
      "UI/UX Design",
      "UI Design",
      "Web Design",
      "User Interface Design"
    ],
    synonyms: ["Corel  Draw", "Corel- Draw"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  psd: {
    skillName: "PSD",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  w3c: {
    skillName: "w3c",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  wireframe: {
    skillName: "wireframe",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["wiref rame", "wiref-rame", "wireframing"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "wiref rame": {
    skillName: "wireframe",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["wiref rame", "wiref-rame", "wireframing"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "wiref-rame": {
    skillName: "wireframe",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["wiref rame", "wiref-rame", "wireframing"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  wireframing: {
    skillName: "wireframe",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["wiref rame", "wiref-rame", "wireframing"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  photoshop: {
    skillName: "Photoshop",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["Photo shop", "Photo-shop"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "photo shop": {
    skillName: "Photoshop",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["Photo shop", "Photo-shop"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "photo-shop": {
    skillName: "Photoshop",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["Photo shop", "Photo-shop"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  prototype: {
    skillName: "prototype",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["proto type", "proto-type", "prototyping"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "proto type": {
    skillName: "prototype",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["proto type", "proto-type", "prototyping"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "proto-type": {
    skillName: "prototype",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["proto type", "proto-type", "prototyping"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  prototyping: {
    skillName: "prototype",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["proto type", "proto-type", "prototyping"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  illustrator: {
    skillName: "Illustrator",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["Illus trator", "Illus-trator"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "illus trator": {
    skillName: "Illustrator",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["Illus trator", "Illus-trator"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "illus-trator": {
    skillName: "Illustrator",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["Illus trator", "Illus-trator"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  multimedia: {
    skillName: "Multimedia",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["Multi media", "Multi-media"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "multi media": {
    skillName: "Multimedia",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["Multi media", "Multi-media"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "multi-media": {
    skillName: "Multimedia",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["Multi media", "Multi-media"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "material design": {
    skillName: "Material Design",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  phonegap: {
    skillName: "PhoneGap",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  cordova: {
    skillName: "Cordova",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  reactnative: {
    skillName: "ReactNative",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["React-Native", "React Native"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "react-native": {
    skillName: "ReactNative",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["React-Native", "React Native"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "react native": {
    skillName: "ReactNative",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: ["React-Native", "React Native"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "programming languages": {
    skillName: "Programming Languages",
    explanation: "A language to communicate with machines",
    synonyms: []
  },
  "user interface": {
    skillName: "User Interface",
    explanation:
      "Used for designing or developing visual interfaces on both web and Mobile",
    synonyms: ["FrontEnd"]
  },
  frontend: {
    skillName: "User Interface",
    explanation:
      "Used for designing or developing visual interfaces on both web and Mobile",
    synonyms: ["FrontEnd"]
  },
  serverside: {
    skillName: "ServerSide",
    explanation: "Anything which is related to backend development",
    synonyms: ["Backend"]
  },
  backend: {
    skillName: "ServerSide",
    explanation: "Anything which is related to backend development",
    synonyms: ["Backend"]
  },
  webservices: {
    skillName: "Webservices",
    primaryFamily: "webservices",
    explanation: "Binds UI to DataBase",
    synonyms: [
      "Webservice",
      `"Web service"`,
      "Rest",
      "Restful",
      "Restfull",
      "SOAP"
    ]
  },
  "web services": {
    primaryFamily: "webservices",
    skillName: "Webservices",
    explanation: "Binds UI to DataBase",
    synonyms: [
      "Webservice",
      `"Web service"`,
      "Rest",
      "Restful",
      "Restfull",
      "SOAP"
    ]
  },
  "web service": {
    skillName: "Webservices",
    primaryFamily: "webservices",
    explanation: "Binds UI to DataBase",
    synonyms: [
      "Webservice",
      `"Web service"`,
      "Rest",
      "Restful",
      "Restfull",
      "SOAP"
    ]
  },
  webservice: {
    skillName: "Webservices",
    primaryFamily: "webservices",
    explanation: "Binds UI to DataBase",
    synonyms: [
      "Webservice",
      `"Web service"`,
      "Rest",
      "Restful",
      "Restfull",
      "SOAP"
    ]
  },
  rest: {
    skillName: "Webservices",
    primaryFamily: "webservices",
    explanation: "Binds UI to DataBase",
    synonyms: [
      "Webservice",
      `"Web service"`,
      "Rest",
      "Restful",
      "Restfull",
      "SOAP"
    ]
  },
  "operating system": {
    skillName: "Operating System",
    explanation:
      "Low-level software that supports a computer's basic functions",
    synonyms: ["Linux"]
  },
  linux: {
    skillName: "Operating System",
    primaryFamily: "OS",
    explanation:
      "Low-level software that supports a computer's basic functions",
    synonyms: ["Linux"]
  },
  "framework / tool": {
    skillName: "Framework / tool",
    explanation:
      "A Supportive element of a programming language or a software module",
    synonyms: []
  },
  "application server": {
    skillName: "Application Server",
    primaryFamily: "Application server",
    explanation: "Entire code gets compiled here",
    synonyms: ["App Server"]
  },
  "app server": {
    skillName: "Application Server",
    explanation: "Entire code gets compiled here",
    primaryFamily: "Application server",
    synonyms: ["App Server"]
  },
  database: {
    skillName: "Database",
    explanation: "Stores the data of any application",
    synonyms: ["DB"]
  },
  db: {
    skillName: "Database",
    explanation: "Stores the data of any application",
    synonyms: ["DB"]
  },
  ide: {
    skillName: "IDE",
    explanation: "Interface on which code is written",
    synonyms: ["Integrated Development Environment"]
  },
  "integrated development environment": {
    skillName: "IDE",
    explanation: "Interface on which code is written",
    synonyms: ["Integrated Development Environment"]
  },
  "app servers etc": {
    skillName: "Infrastructure",
    explanation: "This refers to any of the physical components like Storage",
    synonyms: ["app servers etc"]
  },
  iaas: {
    skillName: "Cloud",
    explanation:
      "Cloud is nothing but using the entire infrastructure based on the need from a service provider without owning it.",
    synonyms: ["IaaS"]
  },
  methodologies: {
    skillName: "Methodologies",
    explanation: "An environment or a practice in which tasks are achieved",
    synonyms: []
  },
  oops: {
    skillName: "OOPS",
    explanation: "Fundamentals of a programming language",
    synonyms: []
  },
  orm: {
    skillName: "ORM",
    explanation:
      "Object relational mapping is a technique for converting data between incompatible type systems using OOPS",
    synonyms: []
  },
  fullstack: {
    skillName: "FullStack",
    explanation: "Consists of both Client side and serverside",
    synonyms: ["Full Stack"]
  },
  "full stack": {
    skillName: "FullStack",
    explanation: "Consists of both Client side and serverside",
    synonyms: ["Full Stack"]
  },
  json: {
    skillName: "JSON",
    explanation: "A Structure in which data is stored/retrieved",
    synonyms: []
  },
  "artificial intelligence": {
    skillName: "Artificial Intelligence",
    explanation: "An art of making machines learn from the data",
    synonyms: ["Data science"]
  },
  "data science": {
    skillName: "Artificial Intelligence",
    explanation: "An art of making machines learn from the data",
    synonyms: ["Data science"]
  },
  microservices: {
    skillName: "MicroServices",
    explanation: "Breaking down services/APIs into micro components.",
    synonyms: ["Micro Service"]
  },
  "micro service": {
    skillName: "MicroServices",
    explanation: "Breaking down services/APIs into micro components.",
    synonyms: ["Micro Service"]
  },
  bigdata: {
    skillName: "BigData",
    explanation:
      "Big data is a term that describes the large volume of data – both structured and unstructured – that inundates a business on a day-to-day basis",
    synonyms: [
      "Bigdata",
      "Big Data",
      "Hadoop",
      "HDFS",
      "Hbase",
      "Hive",
      "Mapreduce",
      "Map Reduce",
      "Pig",
      "Scala",
      "Storm"
    ]
  },
  "big data": {
    skillName: "BigData",
    explanation:
      "Big data is a term that describes the large volume of data – both structured and unstructured – that inundates a business on a day-to-day basis",
    synonyms: ["Big Data"]
  },
  script: {
    skillName: "Script",
    explanation:
      "Programs written for a special run-time environment that automate the execution of tasks",
    synonyms: ["Scripting"]
  },
  scripting: {
    skillName: "Script",
    explanation:
      "Programs written for a special run-time environment that automate the execution of tasks",
    synonyms: ["Scripting"]
  },
  devops: {
    skillName: "Devops",
    explanation:
      "Its a culture and practice that aims at unifying software development and software operation.",
    synonyms: ["Dev ops", "dev-ops"]
  },
  "dev ops": {
    skillName: "Devops",
    explanation:
      "Its a culture and practice that aims at unifying software development and software operation.",
    synonyms: ["Dev ops", "dev-ops"]
  },
  "dev-ops": {
    skillName: "Devops",
    explanation:
      "Its a culture and practice that aims at unifying software development and software operation.",
    synonyms: ["Dev ops", "dev-ops"]
  },
  "core java": {
    skillName: "Java",
    explanation: "Programming Language",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Core Java", "CoreJava", "J2EE", "JSEE", "J2SE"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  corejava: {
    skillName: "Java",
    explanation: "Programming Language",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Core Java", "CoreJava", "J2EE", "JSEE", "J2SE"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  java: {
    skillName: "Java",
    explanation: "Programming Language",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Java", "Core Java", "CoreJava", "J2EE", "JSEE", "J2SE"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  j2ee: {
    skillName: "Java",
    explanation: "Programming Language",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Core Java", "CoreJava", "J2EE", "JSEE", "J2SE"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  jsee: {
    skillName: "Java",
    explanation: "Programming Language",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Core Java", "CoreJava", "J2EE", "JSEE", "J2SE"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  j2se: {
    skillName: "Java",
    explanation: "Programming Language",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Core Java", "CoreJava", "J2EE", "JSEE", "J2SE"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  spring: {
    skillName: "Spring",
    explanation: "Backend framework belonging to Java Family",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Spring, SpringMVC, SpringBoot, SpringAOP"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "spring boot": {
    skillName: "Spring Boot",
    explanation:
      "Simplies your Spring dependencies like no version collisions etc.",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide", "Spring"],
    synonyms: [
      "SpringBOOT",
      `"Spring boot"`,
      "SpringMVC",
      "Spring",
      "SpringAOP"
    ],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  springboot: {
    skillName: "Spring Boot",
    explanation:
      "Simplies your Spring dependencies like no version collisions etc.",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide", "Spring"],
    synonyms: [
      "Springboot",
      `"Spring boot"`,
      "SpringMVC",
      "Spring",
      "SpringAOP"
    ],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "spring mvc": {
    skillName: "Spring MVC",
    explanation:
      "Used to bind your frontend MVC to your backend ORM / Database.",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide", "Spring"],
    synonyms: [
      `"Spring MVC"`,
      "SpringMVC",
      "Spring",
      "SpringBoot",
      "SpringAOP"
    ],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  springmvc: {
    skillName: "Spring MVC",
    explanation:
      "Used to bind your frontend MVC to your backend ORM / Database.",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide", "Spring"],
    synonyms: [
      `"Spring MVC"`,
      "SpringMVC",
      "Spring",
      "SpringBoot",
      "SpringAOP"
    ],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "spring ioc": {
    skillName: "Spring IOC",
    explanation: "Part of Spring Framework",
    primaryFamily: "It will create the objects",
    secondaryFamily: ["wire them together"],
    synonyms: [
      "configure and manage complete life cycle from creation till destruction."
    ],
    versions: ["Java"],
    similarTech: ["Backend Development", "ServerSide", "Spring"],
    type: "SpringIOC",
    booleanSynonyms: []
  },
  "configure and manage complete life cycle from creation till destruction.": {
    skillName: "Spring IOC",
    explanation: "Part of Spring Framework",
    primaryFamily: "It will create the objects",
    secondaryFamily: ["wire them together"],
    synonyms: [
      "configure and manage complete life cycle from creation till destruction."
    ],
    versions: ["Java"],
    similarTech: ["Backend Development", "ServerSide", "Spring"],
    type: "SpringIOC",
    booleanSynonyms: []
  },
  "spring security": {
    skillName: "Spring Security",
    explanation:
      "Spring security can be used for authentication and authorization purposes in an application",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide", "Spring"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "spring aop": {
    skillName: "Spring AOP",
    explanation:
      "A module of Spring which compliments OOPS & helps in more effecient code.",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide", "Spring"],
    synonyms: [`"SpringAOP"`, "SpringAOP", "SpringMVC", "SpringBoot", "Spring"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  springaop: {
    skillName: "Spring AOP",
    explanation:
      "A module of Spring which compliments OOPS & helps in more effecient code.",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide", "Spring"],
    synonyms: [
      `"Spring AOP"`,
      "SpringAOP",
      "SpringMVC",
      "SpringBoot",
      "Spring"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  mybatis: {
    skillName: "Mybatis",
    explanation: "Its an ORM technology",
    primaryFamily: "Java- ORM",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [
      "ORM",
      "Mybatis",
      "Ibatis",
      "JPA",
      "My batis",
      "JPA2",
      "Hibernate"
    ],
    versions: [],
    similarTech: ["Hibernate", "Mybatis", "Ibatis"],
    type: "Framework",
    booleanSynonyms: []
  },
  "my batis": {
    skillName: "Mybatis",
    explanation: "Its an ORM technology",
    primaryFamily: "Java- ORM",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [
      "ORM",
      "Mybatis",
      "Ibatis",
      "JPA",
      "My batis",
      "JPA2",
      "Hibernate"
    ],
    versions: [],
    similarTech: ["Hibernate", "Mybatis", "Ibatis"],
    type: "Framework",
    booleanSynonyms: []
  },
  ibatis: {
    skillName: "iBatis",
    explanation: "Its an ORM technology",
    primaryFamily: "Java- ORM",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [
      "ORM",
      "Mybatis",
      "Ibatis",
      "JPA",
      "My batis",
      "JPA2",
      "Hibernate"
    ],
    versions: ["JPA2"],
    similarTech: ["Hibernate", "Mybatis", "Ibatis"],
    type: "Framework",
    booleanSynonyms: []
  },
  jpa2: {
    skillName: "JPA",
    explanation: "Its an ORM technology",
    primaryFamily: "Java- ORM",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [
      "ORM",
      "Mybatis",
      "Ibatis",
      "JPA",
      "My batis",
      "JPA2",
      "Hibernate"
    ],
    versions: ["JPA2"],
    similarTech: ["Hibernate", "Mybatis", "Ibatis"],
    type: "Framework",
    booleanSynonyms: []
  },
  jpa: {
    skillName: "JPA",
    explanation: "Its an ORM technology",
    primaryFamily: "Java- ORM",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [
      "ORM",
      "Mybatis",
      "Ibatis",
      "JPA",
      "My batis",
      "JPA2",
      "Hibernate"
    ],
    versions: ["JPA2"],
    similarTech: ["Hibernate", "Mybatis", "Ibatis"],
    type: "Framework",
    booleanSynonyms: []
  },
  hibernate: {
    skillName: "Hibernate",
    explanation: "Its an ORM technology",
    primaryFamily: "Java- ORM",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [
      "ORM",
      "Mybatis",
      "Ibatis",
      "JPA",
      "My batis",
      "JPA2",
      "Hibernate"
    ],
    versions: [],
    similarTech: ["Hibernate", "Mybatis", "Ibatis"],
    type: "Framework",
    booleanSynonyms: []
  },
  struts: {
    skillName: "Struts",
    explanation:
      "A Framework which Combines JSP, Servlets provides a synergetic platform",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Backend Development", "ServerSide"],
    similarTech: ["JPA2"],
    versions: ["Struts2", "struts1.2"],
    type: "Framework",
    booleanSynonyms: []
  },
  struts2: {
    skillName: "Servlets",
    explanation:
      "Servlets are server-side Java program modules that process and answer client / UI requests",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "struts1.2": {
    skillName: "Servlets",
    explanation:
      "Servlets are server-side Java program modules that process and answer client / UI requests",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  servlets: {
    skillName: "Servlets",
    explanation:
      "Servlets are server-side Java program modules that process and answer client / UI requests",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  jsp: {
    skillName: "JSP",
    explanation:
      "Java Server Pages (JSP) is a server-side programming technology that enables the creation of dynamic, platform-independent method for building Web-based applications",
    primaryFamily: "Java",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  jdbc: {
    skillName: "JDBC",
    explanation:
      "Java Database Connectivity (JDBC) is an application program interface (API) specification for connecting programs written in Java to the data in popular databases",
    primaryFamily: "Java- ORM",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  mern: {
    skillName: "MERN",
    explanation: "Web application stack",
    primaryFamily: "stack",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [
      "(MERN OR ((Mongo OR Mongodb) AND (Express OR Expressjs) AND (React OR Reactjs) AND (Node OR Nodejs)))"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  mean: {
    skillName: "MEAN",
    explanation: "Web application stack",
    primaryFamily: "stack",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [
      " (MEAN OR ((Mongo OR Mongodb) AND (Express OR Expressjs) AND (Angular OR angularjs) AND (Node OR Nodejs)))"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  python: {
    skillName: "Python",
    explanation: "Programming Language",
    primaryFamily: "Programming Languages- ServerSide- Script",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  django: {
    skillName: "Django",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  falcon: {
    skillName: "Falcon",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  masonite: {
    skillName: "Masonite",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  flask: {
    skillName: "Flask",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  cherrypi: {
    skillName: "CherryPy",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  bottle: {
    skillName: "Bottle",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  tornado: {
    skillName: "Tornado",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  hug: {
    skillName: "Hug",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  pyramid: {
    skillName: "Pyramid",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  flask: {
    skillName: "Flask",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  flask: {
    skillName: "Flask",
    explanation: "Python based framework",
    primaryFamily: "Python",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  php: {
    skillName: "PHP",
    explanation: "Programming Language",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  drupal: {
    skillName: "Drupal",
    explanation: "Open sourced Framework written in PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  codeigniter: {
    skillName: "CodeIgniter",
    explanation:
      "Open-source software rapid development web framework, for use in building dynamic web sites with PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Code Igniter"],
    versions: ["CodeIgniter2", "CodeIgniter3", "CodeIgniter4"],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "code igniter": {
    skillName: "CodeIgniter",
    explanation:
      "Open-source software rapid development web framework, for use in building dynamic web sites with PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Code Igniter"],
    versions: ["CodeIgniter2", "CodeIgniter3", "CodeIgniter4"],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  nodejs: {
    skillName: "NodeJs",
    explanation: "JavaScript based framework",
    primaryFamily: "Nodejs",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Node", "Nodejs", "Node.js"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  expressjs: {
    skillName: "EXpressJs",
    explanation: "JavaScript based framework",
    primaryFamily: "Nodejs",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Expressjs", "express", "Express.js"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  express: {
    skillName: "Flask",
    explanation: "JavaScript based framework",
    primaryFamily: "JavaScript",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  node: {
    skillName: "Flask",
    explanation: "JavaScript based framework",
    primaryFamily: "JavaScript",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  laravel: {
    skillName: "Laravel",
    explanation: "Open sourced Framework written in PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  symfony: {
    skillName: "Symfony",
    explanation: "Open sourced Framework written in PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  zend: {
    skillName: "Zend",
    explanation: "Open sourced Framework written in PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  phalcon: {
    skillName: "Phalcon",
    explanation: "Open sourced Framework written in PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  cakephp: {
    skillName: "CakePHP",
    explanation: "Open sourced Framework written in PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Cake PHP"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "cake php": {
    skillName: "CakePHP",
    explanation: "Open sourced Framework written in PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Cake PHP"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  yii: {
    skillName: "Yii",
    explanation: "Open sourced Framework written in PHP",
    primaryFamily: "PHP",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  ".net": {
    skillName: ".Net",
    explanation:
      "A framework developed by Microsoft that runs primarily on Microsoft Windows.",
    primaryFamily: "C#- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["DotNet", "Dot Net", "Dot-Net", ".Net"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  dotnet: {
    skillName: ".Net",
    explanation:
      "A framework developed by Microsoft that runs primarily on Microsoft Windows.",
    primaryFamily: "C#- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["DotNet", "Dot Net", "Dot-Net", ".Net"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "dot net": {
    skillName: ".Net",
    explanation:
      "A framework developed by Microsoft that runs primarily on Microsoft Windows.",
    primaryFamily: "C#- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["DotNet", "Dot Net", "Dot-Net", ".Net"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "dot-net": {
    skillName: ".Net",
    explanation:
      "A framework developed by Microsoft that runs primarily on Microsoft Windows.",
    primaryFamily: "C#- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["DotNet", "Dot Net", "Dot-Net", ".Net"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "asp.net": {
    skillName: "Asp.net",
    explanation:
      "Web application framework designed for web development to produce dynamic web pages",
    primaryFamily: "C#- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Aspnet", "Asp.net", "Asp"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  aspnet: {
    skillName: "Asp.net",
    explanation:
      "Web application framework designed for web development to produce dynamic web pages",
    primaryFamily: "C#- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Aspnet", "Asp.net", "Asp"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  asp: {
    skillName: "Asp.net",
    explanation:
      "Web application framework designed for web development to produce dynamic web pages",
    primaryFamily: "C#- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Aspnet", "Asp.net", "Asp"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "vb.net": {
    skillName: "VB.NET",
    explanation:
      "Visual Basic is a programming language designed for creating a variety of applications that run on the .NET Framework",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["VB", "Visual Basic", "VBnet", "VB.NET", "VBNET"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  vb: {
    skillName: "VB.NET",
    explanation:
      "Visual Basic is a programming language designed for creating a variety of applications that run on the .NET Framework",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["VB", "Visual Basic", "VBnet", "VB.NET", "VBNET"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "visual basic": {
    skillName: "VB.NET",
    explanation:
      "Visual Basic is a programming language designed for creating a variety of applications that run on the .NET Framework",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["VB", "Visual Basic", "VBnet", "VB.NET", "VBNET"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  vbnet: {
    skillName: "VB.NET",
    explanation:
      "Visual Basic is a programming language designed for creating a variety of applications that run on the .NET Framework",
    primaryFamily: "Programming Languages- ServerSide",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["VB", "Visual Basic", "VBnet", "VB.NET", "VBNET"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "ado.net": {
    skillName: "Ado.Net",
    explanation:
      "ADO.NET provides a bridge between the front end controls and the back end database.",
    primaryFamily: ".Net",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["ADO", "ADONet", "ado net"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  ado: {
    skillName: "Ado.Net",
    explanation:
      "ADO.NET provides a bridge between the front end controls and the back end database.",
    primaryFamily: ".Net",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["ADO", "ADONet", "ado net"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  adonet: {
    skillName: "Ado.Net",
    explanation:
      "ADO.NET provides a bridge between the front end controls and the back end database.",
    primaryFamily: ".Net",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["ADO", "ADONet", "ado net"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "ado net": {
    skillName: "Ado.Net",
    explanation:
      "ADO.NET provides a bridge between the front end controls and the back end database.",
    primaryFamily: ".Net",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["ADO", "ADONet", "ado net"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  entityframework: {
    skillName: "Entityframework",
    explanation:
      "ADO.NET provides a bridge between the front end controls and the back end database.",
    primaryFamily: "Database",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Entity", "Entityframework", "EF"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  wcf: {
    skillName: "WCF",
    explanation: "A framework for building service-oriented applications",
    primaryFamily: ".Net- C#",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: ["Webservice"],
    type: "Framework",
    booleanSynonyms: []
  },
  wpf: {
    skillName: "WPF",
    explanation: ".Net based framework used in the Presentation layer",
    primaryFamily: ".Net- C#",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "c#": {
    skillName: "C#",
    explanation: "Programming Language",
    primaryFamily: "Programming Language",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["C Sharp"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "c sharp": {
    skillName: "C#",
    explanation: "Programming Language",
    primaryFamily: "Programming Language",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["C Sharp"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "entity framework": {
    skillName: "Entity Framework",
    explanation:
      "Entity Framework is an open source object-relational mapping framework",
    primaryFamily: ".Net- C#- ORM",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["EF"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  ef: {
    skillName: "Entity Framework",
    explanation:
      "Entity Framework is an open source object-relational mapping framework",
    primaryFamily: ".Net- C#- ORM",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["EF"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  webapi: {
    skillName: "WebAPI",
    explanation:
      "Web API is a framework that makes it easy to build HTTP services that interact with UI.",
    primaryFamily: ".Net- C#",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Web API"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  "web api": {
    skillName: "WebAPI",
    explanation:
      "Web API is a framework that makes it easy to build HTTP services that interact with UI.",
    primaryFamily: ".Net- C#",
    secondaryFamily: ["Backend Development", "ServerSide"],
    synonyms: ["Web API"],
    versions: [],
    similarTech: [],
    type: "Framework",
    booleanSynonyms: []
  },
  threading: {
    skillName: "Threading",
    explanation:
      "Method or concept of executing multiple processes or threads concurrently",
    primaryFamily: "Thread",
    secondaryFamily: [""],
    synonyms: [
      "Thread",
      "Threading",
      "Socket",
      "Stream",
      "Concurrent",
      "Concurrency",
      "Concurrently",
      "Multithread",
      "Multithreading",
      `"multi thread"`,
      `"Multi threading"`
    ],
    versions: [
      "Threads",
      "Thread",
      "Multithread",
      "Multithreading",
      "Concurrent",
      "Concurrently"
    ],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  threads: {
    skillName: "Threading",
    explanation:
      "Method or concept of executing multiple processes or threads concurrently",
    primaryFamily: "Thread",
    secondaryFamily: [""],
    synonyms: [
      "Thread",
      "Threading",
      "Socket",
      "Stream",
      "Concurrent",
      "Concurrency",
      "Concurrently",
      "Multithread",
      "Multithreading",
      `"multi thread"`,
      `"Multi threading"`
    ],
    versions: [
      "Threads",
      "Thread",
      "Multithread",
      "Multithreading",
      "Concurrent",
      "Concurrently"
    ],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  thread: {
    skillName: "Threading",
    explanation:
      "Method or concept of executing multiple processes or threads concurrently",
    primaryFamily: "Thread",
    secondaryFamily: [""],
    synonyms: [
      "Thread",
      "Threading",
      "Socket",
      "Stream",
      "Concurrent",
      "Concurrency",
      "Concurrently",
      "Multithread",
      "Multithreading",
      `"multi thread"`,
      `"Multi threading"`
    ],
    versions: [
      "Threads",
      "Thread",
      "Multithread",
      "Multithreading",
      "Concurrent",
      "Concurrently"
    ],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  multithread: {
    skillName: "Threading",
    explanation:
      "Method or concept of executing multiple processes or threads concurrently",
    primaryFamily: "Thread",
    secondaryFamily: [""],
    synonyms: [
      "Thread",
      "Threading",
      "Socket",
      "Stream",
      "Concurrent",
      "Concurrency",
      "Concurrently",
      "Multithread",
      "Multithreading",
      `"multi thread"`,
      `"Multi threading"`
    ],
    versions: [
      "Threads",
      "Thread",
      "Multithread",
      "Multithreading",
      "Concurrent",
      "Concurrently"
    ],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  multithreading: {
    skillName: "Threading",
    explanation:
      "Method or concept of executing multiple processes or threads concurrently",
    primaryFamily: "Thread",
    secondaryFamily: [""],
    synonyms: [
      "Thread",
      "Threading",
      "Socket",
      "Stream",
      "Concurrent",
      "Concurrency",
      "Concurrently",
      "Multithread",
      "Multithreading",
      `"multi thread"`,
      `"Multi threading"`
    ],
    versions: [
      "Threads",
      "Thread",
      "Multithread",
      "Multithreading",
      "Concurrent",
      "Concurrently"
    ],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  concurrent: {
    skillName: "Threading",
    explanation:
      "Method or concept of executing multiple processes or threads concurrently",
    primaryFamily: "Thread",
    secondaryFamily: [""],
    synonyms: [
      "Thread",
      "Threading",
      "Socket",
      "Stream",
      "Concurrent",
      "Concurrency",
      "Concurrently",
      "Multithread",
      "Multithreading",
      `"multi thread"`,
      `"Multi threading"`
    ],
    versions: [
      "Threads",
      "Thread",
      "Multithread",
      "Multithreading",
      "Concurrent",
      "Concurrently"
    ],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  concurrently: {
    skillName: "Threading",
    explanation:
      "Method or concept of executing multiple processes or threads concurrently",
    primaryFamily: "Thread",
    secondaryFamily: [""],
    synonyms: [
      "Thread",
      "Threading",
      "Socket",
      "Stream",
      "Concurrent",
      "Concurrency",
      "Concurrently",
      "Multithread",
      "Multithreading",
      `"multi thread"`,
      `"Multi threading"`
    ],
    versions: [
      "Threads",
      "Thread",
      "Multithread",
      "Multithreading",
      "Concurrent",
      "Concurrently"
    ],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  queue: {
    skillName: "Queue",
    // explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Queue",
    secondaryFamily: [],
    synonyms: [
      "Queue",
      "Queueing",
      "MQ",
      "ActiveMQ",
      "RabbitMQ",
      "Hornetq",
      "Kafka"
    ],
    versions: [],
    similarTech: ["ActiveMQ", "RabbitMQ", "Hornetq", "Kafka"],
    type: "",
    booleanSynonyms: []
  },
  Queueing: {
    skillName: "Queue",
    // explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Queue",
    secondaryFamily: [],
    synonyms: [
      "Queue",
      "Queueing",
      "MQ",
      "ActiveMQ",
      "RabbitMQ",
      "Hornetq",
      "Kafka"
    ],
    versions: [],
    similarTech: ["ActiveMQ", "RabbitMQ", "Hornetq", "Kafka"],
    type: "",
    booleanSynonyms: []
  },
  activemq: {
    skillName: "ActiveMQ",
    // explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Queue",
    secondaryFamily: [],
    synonyms: ["Queue", "Queueing", "ActiveMQ"],
    versions: [],
    similarTech: ["ActiveMQ", "RabbitMQ", "Hornetq", "Kafka"],
    type: "",
    booleanSynonyms: []
  },
  mq: {
    skillName: "mq",
    // explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Queue",
    secondaryFamily: [],
    synonyms: ["Queue", "Queueing", "MQ"],
    versions: [],
    similarTech: ["ActiveMQ", "RabbitMQ", "Hornetq", "Kafka"],
    type: "",
    booleanSynonyms: []
  },
  rabbitmq: {
    skillName: "RabbitMQ",
    // explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Queue",
    secondaryFamily: [],
    synonyms: ["Queue", "Queueing", "RabbitMQ"],
    versions: [],
    similarTech: ["ActiveMQ", "RabbitMQ", "Hornetq", "Kafka"],
    type: "",
    booleanSynonyms: []
  },
  kafka: {
    skillName: "Kafka",
    primaryFamily: "Queue",
    explanation:
      "Apache Kafka is an open-source stream-processing software platform developed by the Apache Software Foundation written in Scala and Java.",
    secondaryFamily: [],
    synonyms: ["Queue", "Queueing", "Kafka"],
    versions: [],
    similarTech: ["ActiveMQ", "RabbitMQ", "Hornetq", "Kafka"],
    type: "",
    booleanSynonyms: []
  },
  hornetq: {
    skillName: "HornetQ",
    // explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Queue",
    secondaryFamily: [],
    synonyms: [
      "Queue",
      "Queueing",
      "MQ",
      "ActiveMQ",
      "RabbitMQ",
      "Hornetq",
      "Kafka"
    ],
    versions: [],
    similarTech: ["ActiveMQ", "RabbitMQ", "Hornetq", "Kafka"],
    type: "",
    booleanSynonyms: []
  },

  aws: {
    skillName: "AWS",
    explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Cloud",
    secondaryFamily: ["Infrastructure"],
    synonyms: ["AWS", `"Amazon webservice"`, `"Amazon web service"`, "EC2"],
    versions: [],
    similarTech: ["Azure", "OpenStack", `"Google Cloud"`],
    type: "",
    booleanSynonyms: []
  },
  "amazon web services": {
    skillName: "AWS",
    explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Cloud",
    secondaryFamily: ["Infrastructure"],
    synonyms: ["AWS", `"Amazon webservice"`, `"Amazon web service"`, "EC2"],
    versions: [],
    similarTech: ["Azure", "OpenStack", `"Google Cloud"`],
    type: "",
    booleanSynonyms: []
  },
  ec2: {
    skillName: "AWS",
    explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Cloud",
    secondaryFamily: ["Infrastructure"],
    synonyms: ["AWS", `"Amazon webservice"`, `"Amazon web service"`, "EC2"],
    versions: [],
    similarTech: ["Azure", "OpenStack", `"Google Cloud"`],
    type: "",
    booleanSynonyms: []
  },
  gcp: {
    skillName: "GCP",
    explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Cloud",
    secondaryFamily: ["Infrastructure"],
    synonyms: ["GCP", `"Google cloud"`],
    versions: [],
    similarTech: ["Azure", "OpenStack", "AWS"],
    type: "",
    booleanSynonyms: []
  },
  "google cloud": {
    skillName: "GCP",
    explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Cloud",
    secondaryFamily: ["Infrastructure"],
    synonyms: ["GCP", `"Google cloud"`],
    versions: [],
    similarTech: ["Azure", "OpenStack", "AWS"],
    type: "",
    booleanSynonyms: []
  },
  "google cloud platform": {
    skillName: "GCP",
    explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Cloud",
    secondaryFamily: ["Infrastructure"],
    synonyms: ["GCP", `"Google cloud"`],
    versions: [],
    similarTech: ["Azure", "OpenStack", "AWS"],
    type: "",
    booleanSynonyms: []
  },
  azure: {
    skillName: "Azure",
    explanation: "A Cloud Services Platform by Microsoft",
    primaryFamily: "Cloud",
    secondaryFamily: ["Infrastructure"],
    synonyms: [],
    versions: [],
    similarTech: ["AWS", "OpenStack", `"Google Cloud"`],
    type: "",
    booleanSynonyms: []
  },
  cloudfoundry: {
    skillName: "Cloudfoundry",
    explanation: "A Cloud Services Platform by Amazon",
    primaryFamily: "Cloud",
    secondaryFamily: ["Infrastructure"],
    synonyms: ["Cloudfoundry", "Cloud foundry"],
    versions: [],
    similarTech: ["Azure", "OpenStack", `"Google Cloud"`],
    type: "",
    booleanSynonyms: []
  },
  docker: {
    skillName: "Docker",
    explanation:
      "Docker is a computer program that performs operating-system-level virtualization also known as containerization",
    primaryFamily: "Docker",
    secondaryFamily: ["Cloud"],
    synonyms: [
      "container",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Mesos",
      "Swarm",
      "Microservice",
      "Micro service"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: [
      "Container",
      "Containerization",
      "Kubernetes",
      "Mesos",
      "Nomad",
      "swarm\r"
    ]
  },
  container: {
    skillName: "Container",
    explanation: "",
    primaryFamily: "Docker",
    secondaryFamily: [],
    synonyms: [
      "container",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Mesos",
      "Swarm",
      "Microservice",
      "Micro service"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: ["Docker", "Kubernetes", "Mesos", "Nomad", "swarm\r"]
  },
  containerization: {
    skillName: "Container",
    explanation: "",
    primaryFamily: "Docker",
    secondaryFamily: [],
    synonyms: [
      "container",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Mesos",
      "Swarm",
      "Microservice",
      "Micro service"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: ["Docker", "Kubernetes", "Mesos", "Nomad", "swarm\r"]
  },
  kubernetes: {
    skillName: "Kubernetes",
    explanation: "container orchestration tool",
    primaryFamily: "Docker , Container",
    secondaryFamily: [],
    synonyms: [
      "container",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Microservice",
      "Micro service"
    ],
    versions: [],
    similarTech: ["Swarm", "Mesos", "Nomad"],
    type: "",
    booleanSynonyms: []
  },
  swarm: {
    skillName: "Swarm",
    explanation: "container orchestration tool",
    primaryFamily: "Docker -Container",
    secondaryFamily: [],
    synonyms: [
      "container",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Mesos",
      "Swarm",
      "Microservice",
      "Micro service"
    ],
    versions: [],
    similarTech: ["Kubernetes", "Mesos", "Nomad"],
    type: "",
    booleanSynonyms: []
  },
  mesos: {
    skillName: "Mesos",
    explanation: "container orchestration tool",
    primaryFamily: "Docker , Container",
    secondaryFamily: [],
    synonyms: [
      "container",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Mesos",
      "Swarm",
      "Microservice",
      "Micro service"
    ],
    versions: [],
    similarTech: ["Kubernetes", "Swarm", "Nomad"],
    type: "",
    booleanSynonyms: []
  },
  nomad: {
    skillName: "Nomad",
    explanation: "container orchestration tool",
    primaryFamily: "Docker , Container",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: ["Kubernetes", "Mesos", "Swarm"],
    type: "",
    booleanSynonyms: []
  },
  paas: {
    skillName: "PaaS",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  saas: {
    skillName: "Saas",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  baas: {
    skillName: "BaaS",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  staas: {
    skillName: "Staas",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  nosql: {
    skillName: "NoSQL",
    explanation: "Its an unstructured database",
    primaryFamily: "Database",
    secondaryFamily: ["Unstructured Database"],
    synonyms: [
      "Mongo",
      "mongodb",
      "nosql",
      `"no sql"`,
      "cassandra",
      "cassandradb",
      "dynamo",
      "dynamodb",
      "documentdb",
      "couch",
      "couchdb"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "no-sql": {
    skillName: "NoSQL",
    explanation: "Its an unstructured database",
    primaryFamily: "Database",
    secondaryFamily: ["Unstructured Database"],
    synonyms: [
      "Mongo",
      "mongodb",
      "nosql",
      `"no sql"`,
      "cassandra",
      "cassandradb",
      "dynamo",
      "dynamodb",
      "documentdb",
      "couch",
      "couchdb"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "no sql": {
    skillName: "NoSQL",
    explanation: "Its an unstructured database",
    primaryFamily: "Database",
    secondaryFamily: ["Unstructured Database"],
    synonyms: [
      "Mongo",
      "mongodb",
      "nosql",
      `"no sql"`,
      "cassandra",
      "cassandradb",
      "dynamo",
      "dynamodb",
      "documentdb",
      "couch",
      "couchdb"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  mongodb: {
    skillName: "MongoDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: [
      "Mongo",
      "mongodb",
      "nosql",
      `"no sql"`,
      "cassandra",
      "cassandradb",
      "dynamo",
      "dynamodb",
      "documentdb",
      "couch",
      "couchdb"
    ],
    versions: [],
    similarTech: [
      "CouchDB",
      "MariaDB",
      "CassandraDB",
      "DynamoDB",
      "Documentdb",
      "HDFS"
    ],
    type: "",
    booleanSynonyms: []
  },
  mongo: {
    skillName: "MongoDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: [
      "Mongo",
      "mongodb",
      "nosql",
      `"no sql"`,
      "cassandra",
      "cassandradb",
      "dynamo",
      "dynamodb",
      "documentdb",
      "couch",
      "couchdb"
    ],
    versions: [],
    similarTech: [
      "CouchDB",
      "MariaDB",
      "CassandraDB",
      "DynamoDB",
      "Documentdb",
      "HDFS"
    ],
    type: "",
    booleanSynonyms: []
  },
  couchdb: {
    skillName: "CouchDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["Couch"],
    versions: [],
    similarTech: [
      "MongoDB",
      "MariaDB",
      "CassandraDB",
      "DynamoDB",
      "Documentdb",
      "HDFS"
    ],
    type: "",
    booleanSynonyms: []
  },
  couch: {
    skillName: "CouchDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["Couch"],
    versions: [],
    similarTech: [
      "MongoDB",
      "MariaDB",
      "CassandraDB",
      "DynamoDB",
      "Documentdb",
      "HDFS"
    ],
    type: "",
    booleanSynonyms: []
  },
  mariadb: {
    skillName: "MariaDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["Maria"],
    versions: [],
    similarTech: [
      "MongoDB",
      "CouchDB",
      "CassandraDB",
      "DynamoDB",
      "Documentdb",
      "HDFS"
    ],
    type: "",
    booleanSynonyms: []
  },
  maria: {
    skillName: "MariaDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["Maria"],
    versions: [],
    similarTech: [
      "MongoDB",
      "CouchDB",
      "CassandraDB",
      "DynamoDB",
      "Documentdb",
      "HDFS"
    ],
    type: "",
    booleanSynonyms: []
  },
  cassandradb: {
    skillName: "CassandraDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["Cassandra"],
    versions: [],
    similarTech: [
      "MongoDB",
      "CouchDB",
      "MariaDB",
      "DynamoDB",
      "Documentdb",
      "HDFS"
    ],
    type: "",
    booleanSynonyms: []
  },
  cassandra: {
    skillName: "CassandraDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["Cassandra"],
    versions: [],
    similarTech: [
      "MongoDB",
      "CouchDB",
      "MariaDB",
      "DynamoDB",
      "Documentdb",
      "HDFS"
    ],
    type: "",
    booleanSynonyms: []
  },
  dynamodb: {
    skillName: "DynamoDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["Dynamo"],
    versions: [],
    similarTech: ["MongoDB", "CouchDB", "MariaDB", "Documentdb", "HDFS"],
    type: "",
    booleanSynonyms: []
  },
  dynamo: {
    skillName: "DynamoDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["Dynamo"],
    versions: [],
    similarTech: ["MongoDB", "CouchDB", "MariaDB", "Documentdb", "HDFS"],
    type: "",
    booleanSynonyms: []
  },
  documentdb: {
    skillName: "DocumentDB",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: [],
    versions: [],
    similarTech: ["MongoDB", "CouchDB", "MariaDB", "DynamoDB", "HDFS"],
    type: "",
    booleanSynonyms: []
  },
  hbase: {
    skillName: "Hbase",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["H-base"],
    versions: [],
    similarTech: ["MongoDB", "CouchDB", "MariaDB", "DynamoDB", "Documentdb"],
    type: "",
    booleanSynonyms: []
  },
  "h-base": {
    skillName: "Hbase",
    explanation: "Its an unstructured database",
    primaryFamily: "NoSql",
    secondaryFamily: ["Unstructured Database"],
    synonyms: ["H-base"],
    versions: [],
    similarTech: ["MongoDB", "CouchDB", "MariaDB", "DynamoDB", "Documentdb"],
    type: "",
    booleanSynonyms: []
  },
  sql: {
    skillName: "SQL",
    explanation: "Structured Database",
    primaryFamily: "Database",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  rdbms: {
    skillName: "SQL",
    explanation: "Structured Database",
    primaryFamily: "Database",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: ["RDBMS"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  mysql: {
    skillName: "Mysql",
    explanation: "Structured Database",
    primaryFamily: "SQL",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      "My SQL",
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: ["Oracle", "Postgresql", "Mysql", "DB2", "Sybase"],
    type: "",
    booleanSynonyms: []
  },
  "my sql": {
    skillName: "Mysql",
    explanation: "Structured Database",
    primaryFamily: "SQL",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      "My SQL",
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: ["Oracle", "Postgresql", "Mysql", "DB2", "Sybase"],
    type: "",
    booleanSynonyms: []
  },
  postgresql: {
    skillName: "Postgresql",
    explanation: "Structured Database",
    primaryFamily: "SQL",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      "Postgre sql",
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: ["Oracle", "Mysql", "DB2", "Sybase"],
    type: "",
    booleanSynonyms: []
  },
  "postgre sql": {
    skillName: "Postgresql",
    explanation: "Structured Database",
    primaryFamily: "SQL",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      "Postgre sql",
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: ["Oracle", "Mysql", "DB2", "Sybase"],
    type: "",
    booleanSynonyms: []
  },
  postgre: {
    skillName: "Postgresql",
    explanation: "Structured Database",
    primaryFamily: "SQL",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      "Postgre sql",
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: ["Oracle", "Mysql", "DB2", "Sybase"],
    type: "",
    booleanSynonyms: []
  },
  postgres: {
    skillName: "Postgresql",
    explanation: "Structured Database",
    primaryFamily: "SQL",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      "Postgre sql",
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: ["Oracle", "Mysql", "DB2", "Sybase"],
    type: "",
    booleanSynonyms: []
  },
  db2: {
    skillName: "DB2",
    explanation: "Structured Database",
    primaryFamily: "SQL",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: ["Oracle", "Mysql", "Postgresql", "Sybase"],
    type: "",
    booleanSynonyms: []
  },
  sybase: {
    skillName: "Sybase",
    explanation: "Structured Database",
    primaryFamily: "SQL",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: ["Oracle", "Mysql", "DB2", "Postgresql"],
    type: "",
    booleanSynonyms: []
  },
  oracle: {
    skillName: "Oracle",
    explanation: "Structured Database",
    primaryFamily: "SQL",
    secondaryFamily: ["Structured Database", "RDBMS"],
    synonyms: [
      " SQL",
      "Mysql",
      "Oracle",
      "Postgre",
      "Postgres",
      "Postgresql",
      "Sybase",
      "PLSQL",
      "PL/SQL"
    ],
    versions: [],
    similarTech: ["Mysql", "DB2", "Postgresql", "DB2", "Sybase"],
    type: "",
    booleanSynonyms: []
  },
  restful: {
    skillName: "Rest",
    explanation: "It's a webservice",
    primaryFamily: "webservices",
    secondaryFamily: [],
    synonyms: [
      "Webservice",
      `"Web service"`,
      "Rest",
      "Restful",
      "Restfull",
      "SOAP"
    ],
    versions: [],
    similarTech: ["SOAP"],
    type: "",
    booleanSynonyms: []
  },
  soap: {
    skillName: "SOAP",
    explanation: "It's a webservice",
    primaryFamily: "webservices",
    secondaryFamily: [],
    synonyms: [
      "Webservice",
      `"Web service"`,
      "Rest",
      "Restful",
      "Restfull",
      "SOAP"
    ],
    versions: [],
    similarTech: ["Rest"],
    type: "",
    booleanSynonyms: []
  },
  api: {
    skillName: "API",
    explanation: "A Medium to save and retrieve data",
    primaryFamily: "webservices",
    secondaryFamily: [],
    synonyms: [
      "Webservice",
      `"Web service"`,
      "Rest",
      "Restful",
      "Restfull",
      "SOAP",
      "api"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  apis: {
    skillName: "API",
    explanation: "A Medium to save and retrieve data",
    primaryFamily: "webservices",
    secondaryFamily: [],
    synonyms: [
      "Webservice",
      `"Web service"`,
      "Rest",
      "Restful",
      "Restfull",
      "SOAP",
      "AP!s"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  tomcat: {
    skillName: "Tomcat",
    explanation: "Java based app server",
    primaryFamily: "Application Server",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: ["Weblogic", "Websphere", "Jboss", "Glassfish"],
    type: "",
    booleanSynonyms: []
  },
  weblogic: {
    skillName: "Weblogic",
    explanation: "Java based app server",
    primaryFamily: "Application Server",
    secondaryFamily: [],
    synonyms: ["web logic"],
    versions: [],
    similarTech: ["Tomcat", "Websphere", "Jboss", "Glassfish"],
    type: "",
    booleanSynonyms: []
  },
  "web logic": {
    skillName: "Weblogic",
    explanation: "Java based app server",
    primaryFamily: "Application Server",
    secondaryFamily: [],
    synonyms: ["web logic"],
    versions: [],
    similarTech: ["Tomcat", "Websphere", "Jboss", "Glassfish"],
    type: "",
    booleanSynonyms: []
  },
  "websphere ": {
    skillName: "Websphere ",
    explanation:
      "It is a software framework and middleware that hosts Java based web application",
    primaryFamily: "Application Server",
    secondaryFamily: [],
    synonyms: ["Web sphere"],
    versions: [],
    similarTech: ["Weblogic", "Tomcat", "Jboss", "Glassfish"],
    type: "",
    booleanSynonyms: []
  },
  "web sphere": {
    skillName: "Websphere ",
    explanation:
      "It is a software framework and middleware that hosts Java based web application",
    primaryFamily: "Application Server",
    secondaryFamily: [],
    synonyms: ["Web sphere"],
    versions: [],
    similarTech: ["Weblogic", "Tomcat", "Jboss", "Glassfish"],
    type: "",
    booleanSynonyms: []
  },
  jboss: {
    skillName: "JBOSS",
    explanation: "App server provided by RedHat",
    primaryFamily: "Application Server",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: ["Weblogic", "Websphere", "Tomcat", "Glassfish"],
    type: "",
    booleanSynonyms: []
  },
  glassfish: {
    skillName: "GlassFish",
    explanation: "",
    primaryFamily: "Application Server",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "version control": {
    skillName: "version control",
    explanation: "Version Controlling tool",
    primaryFamily: "Version Control",
    secondaryFamily: [],
    synonyms: ["Version control", "GIT", "SVN"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  versioncontrol: {
    skillName: "version control",
    explanation: "Version Controlling tool",
    primaryFamily: "Version Control",
    secondaryFamily: [],
    synonyms: ["Version control", "GIT", "SVN"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  git: {
    skillName: "GIT",
    explanation: "Version Controlling tool",
    primaryFamily: "Version Control",
    secondaryFamily: [],
    synonyms: ["Version control", "GIT"],
    versions: [],
    similarTech: ["SVN"],
    type: "",
    booleanSynonyms: []
  },
  svn: {
    skillName: "SVN",
    explanation: "Version Controlling tool",
    primaryFamily: "Version Control",
    secondaryFamily: [],
    synonyms: ["Version control", "SVN"],
    versions: [],
    similarTech: ["GIT"],
    type: "",
    booleanSynonyms: []
  },
  github: {
    skillName: "Github",
    explanation: "Version Controlling tool",
    primaryFamily: "Version Control",
    secondaryFamily: [],
    synonyms: ["Github", "git hub", "Bitbucket", "Bit bucket"],
    versions: [],
    similarTech: ["GIT"],
    type: "",
    booleanSynonyms: []
  },
  eclipse: {
    skillName: "Eclipse",
    explanation: "An IDE mostly used in Java",
    primaryFamily: "IDE",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: ["Netbeans", "Intellij", "visual studio"],
    type: "",
    booleanSynonyms: []
  },
  netbeans: {
    skillName: "NetBeans",
    explanation: "An IDE mostly used in Java",
    primaryFamily: "IDE",
    secondaryFamily: [],
    synonyms: ["Net Beans"],
    versions: [],
    similarTech: ["Eclipse", "Intellij", "visual studio"],
    type: "",
    booleanSynonyms: []
  },
  "net beans": {
    skillName: "NetBeans",
    explanation: "An IDE mostly used in Java",
    primaryFamily: "IDE",
    secondaryFamily: [],
    synonyms: ["Net Beans"],
    versions: [],
    similarTech: ["Eclipse", "Intellij", "visual studio"],
    type: "",
    booleanSynonyms: []
  },
  intellij: {
    skillName: "IntelliJ",
    explanation: "An IDE mostly used in Java",
    primaryFamily: "IDE",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: ["Netbeans", "Intellij", "eclipse"],
    type: "",
    booleanSynonyms: []
  },
  "visual studio": {
    skillName: "Visual Studio",
    explanation: "AN IDE from Microsoft",
    primaryFamily: "IDE",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: ["Netbeans", "Intellij", "eclipse"],
    type: "",
    booleanSynonyms: []
  },
  ant: {
    skillName: "ANT",
    explanation: "",
    primaryFamily: "Build Tools",
    secondaryFamily: [],
    synonyms: ["ANT", "Jenkins", "Gradle", "Hudson", "Maven", "Build tools"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  maven: {
    skillName: "Maven",
    explanation: "",
    primaryFamily: "Build Tools",
    secondaryFamily: [],
    synonyms: ["ANT", "Jenkins", "Gradle", "Hudson", "Maven", "Build tools"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  gradle: {
    skillName: "Gradle",
    explanation: "",
    primaryFamily: "Build Tools",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  hadoop: {
    skillName: "Hbase",
    explanation:
      "HBase is an open-source- non-relational, distributed database modeled after Google's Bigtable and is written in Java",
    primaryFamily: "BigData",
    secondaryFamily: ["NoSQL"],
    synonyms: ["Hadoop"],
    versions: [],
    similarTech: [],
    type: "Cassandra , MongoDB",
    booleanSynonyms: []
  },
  pig: {
    skillName: "Pig",
    explanation:
      "Apache Pig is a high-level platform for creating programs that run on Apache Hadoop.",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop"],
    synonyms: [],
    versions: [],
    similarTech: ["Hive"],
    type: "",
    booleanSynonyms: []
  },
  hive: {
    skillName: "Hive",
    explanation:
      "Apache Hive is a data warehouse software project built on top of Apache Hadoop for providing data summarization, query and analysis.",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop"],
    synonyms: [],
    versions: [],
    similarTech: ["Pig"],
    type: "",
    booleanSynonyms: []
  },
  spark: {
    skillName: "Spark",
    explanation: "Apache Spark is an open,source cluster,computing framework",
    primaryFamily: "BigData",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: ["MapReduce", "Hive", "Pig"],
    type: "",
    booleanSynonyms: []
  },
  zookeeper: {
    skillName: "Zookeeper",
    explanation:
      "It is essentially a centralized service for distributed systems to a hierarchical key-value store, which is used to provide a distributed configuration service, synchronization service and naming registry for large distributed systems",
    primaryFamily: "BigData",
    secondaryFamily: [""],
    synonyms: ["Zoo Keeper", "Zoo-Keeper"],
    versions: [],
    similarTech: ["consul", "eureka", "doozer"],
    type: "",
    booleanSynonyms: []
  },
  "zoo keeper": {
    skillName: "Zookeeper",
    explanation:
      "It is essentially a centralized service for distributed systems to a hierarchical key-value store, which is used to provide a distributed configuration service, synchronization service, and naming registry for large distributed systems",
    primaryFamily: "BigData",
    secondaryFamily: [""],
    synonyms: ["Zoo Keeper", "Zoo-Keeper"],
    versions: [],
    similarTech: ["consul", "eureka", "doozer"],
    type: "",
    booleanSynonyms: []
  },
  "zoo-keeper": {
    skillName: "Zookeeper",
    explanation:
      "It is essentially a centralized service for distributed systems to a hierarchical key-value store, which is used to provide a distributed configuration service, synchronization service, and naming registry for large distributed systems",
    primaryFamily: "BigData",
    secondaryFamily: [""],
    synonyms: ["Zoo Keeper", "Zoo-Keeper"],
    versions: [],
    similarTech: ["consul", "eureka", "doozer"],
    type: "",
    booleanSynonyms: []
  },
  sqoop: {
    skillName: "Sqoop",
    explanation:
      "This is a tool that connects Hadoop with various relational databases to transfer data. This can be effectively used to transfer structured data to Hadoop or Hive.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  oozie: {
    skillName: "Oozie",
    explanation:
      "Apache Oozie is a Java Web application used to schedule Apache Hadoop jobs.",
    primaryFamily: "Bigdata",
    secondaryFamily: ["Hadoop"],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  storm: {
    skillName: "Storm",
    explanation:
      "Apache Storm is a distributed real-time computation system, whose applications are designed as directed acyclic graphs",
    primaryFamily: "BigData",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  jenkins: {
    skillName: "Jenkins",
    explanation:
      "Is used in automating tasks around Continous integration & Deployment",
    primaryFamily: "Build Tools",
    secondaryFamily: ["Devops"],
    synonyms: ["ANT", "Jenkins", "Gradle", "Hudson", "Maven", "Build tools"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  hudson: {
    skillName: "Hudson",
    explanation:
      "Is used in automating tasks around Continous integration & Deployment",
    primaryFamily: "Build Tools",
    secondaryFamily: ["Devops"],
    synonyms: ["ANT", "Jenkins", "Gradle", "Hudson", "Maven", "Build tools"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },

  buildtools: {
    skillName: "build tool",
    explanation:
      "Is used in automating tasks around Continous integration & Deployment",
    primaryFamily: "Build Tools",
    secondaryFamily: ["Devops"],
    synonyms: ["ANT", "Jenkins", "Gradle", "Hudson", "Maven", "Build tools"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  mapreduce: {
    skillName: "MapReduce",
    explanation: "MapReduce is Hadoop's native batch processing engine.",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["Map Reduce"],
    versions: [],
    similarTech: ["Pig", "Hive", "Spark"],
    type: "",
    booleanSynonyms: []
  },
  "map reduce": {
    skillName: "MapReduce",
    explanation: "MapReduce is Hadoop's native batch processing engine.",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["Map Reduce"],
    versions: [],
    similarTech: ["Pig", "Hive", "Spark"],
    type: "",
    booleanSynonyms: []
  },
  hdfs: {
    skillName: "HDFS",
    explanation: "Hadoop Distributed File System",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  cloudera: {
    skillName: "Cloudera",
    explanation: "Most popular open source Hadoop-based platform",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: [],
    versions: [],
    similarTech: ["Hortonworks", "MapR"],
    type: "",
    booleanSynonyms: []
  },
  cdh: {
    skillName: "Cloudera",
    explanation: "Most popular open source Hadoop-based platform",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["CDH"],
    versions: [],
    similarTech: ["Hortonworks", "MapR"],
    type: "",
    booleanSynonyms: []
  },
  ci: {
    skillName: "CI",
    explanation: "Continous Integration in a development environment",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  cd: {
    skillName: "CD",
    explanation: "Continous Deployment in a development environment",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  chef: {
    skillName: "Chef",
    explanation: "Configuration Management tool",
    primaryFamily: "Devops",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: ["puppet", "ansible", "salt"],
    type: "",
    booleanSynonyms: []
  },
  puppet: {
    skillName: "Puppet",
    explanation: "Configuration Management tool",
    primaryFamily: "Devops",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: ["chef", "ansible", "salt"],
    type: "",
    booleanSynonyms: []
  },
  salt: {
    skillName: "Salt",
    explanation: "Configuration Management tool",
    primaryFamily: "Devops",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: ["puppet", "ansible", "chef"],
    type: "",
    booleanSynonyms: []
  },
  ansible: {
    skillName: "Ansible",
    explanation: "Configuration Management tool",
    primaryFamily: "Devops",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: ["puppet", "chef", "salt"],
    type: "",
    booleanSynonyms: []
  },
  hortonworks: {
    skillName: "Hortonworks",
    explanation: "",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["HDF", "HDP", "Horton works", "Horton-works"],
    versions: [],
    similarTech: ["MapR", "Cloudera"],
    type: "",
    booleanSynonyms: []
  },
  hdf: {
    skillName: "Hortonworks",
    explanation: "",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["HDF", "HDP", "Horton works", "Horton-works"],
    versions: [],
    similarTech: ["MapR", "Cloudera"],
    type: "",
    booleanSynonyms: []
  },
  hdp: {
    skillName: "Hortonworks",
    explanation: "",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["HDF", "HDP", "Horton works", "Horton-works"],
    versions: [],
    similarTech: ["MapR", "Cloudera"],
    type: "",
    booleanSynonyms: []
  },
  "horton works": {
    skillName: "Hortonworks",
    explanation: "",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["HDF", "HDP", "Horton works", "Horton-works"],
    versions: [],
    similarTech: ["MapR", "Cloudera"],
    type: "",
    booleanSynonyms: []
  },
  "horton-works": {
    skillName: "Hortonworks",
    explanation: "",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["HDF", "HDP", "Horton works", "Horton-works"],
    versions: [],
    similarTech: ["MapR", "Cloudera"],
    type: "",
    booleanSynonyms: []
  },
  "mapr ": {
    skillName: "MapR ",
    explanation: "",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["Map-R"],
    versions: [],
    similarTech: ["Cloudera", "Hortonworks"],
    type: "",
    booleanSynonyms: []
  },
  "map-r": {
    skillName: "MapR ",
    explanation: "",
    primaryFamily: "BigData",
    secondaryFamily: ["Hadoop "],
    synonyms: ["Map-R"],
    versions: [],
    similarTech: ["Cloudera", "Hortonworks"],
    type: "",
    booleanSynonyms: []
  },
  "ms hdinsight": {
    skillName: "MS HDInsight",
    explanation:
      "It is a Big Data solution from Microsoft powered by Apache Hadoop which is available as a service in the cloud. HDInsight uses Windows Azure Blob storage as the default file system.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  presto: {
    skillName: "Presto",
    explanation:
      "Facebook has developed and recently open-sourced its Query engine (SQL-on-Hadoop) named Presto which is built to handle petabytes of data.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  r: {
    skillName: "R",
    explanation:
      "is a programming language and software environment designed for working with statistics",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  flink: {
    skillName: "Flink",
    explanation:
      "Apache Flink is a streaming dataflow engine, aiming to provide facilities for distributed computation over streams of data.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  samza: {
    skillName: "Samza",
    explanation:
      "Apache Samza is another distributed stream processing framework. Samza is built on Apache Kafka for messaging and YARN for cluster resource management",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  yarn: {
    skillName: "Yarn",
    explanation:
      "YARN, which stands for Yet Another Resource Negotiator, is the cluster coordinating component of the Hadoop stack.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  mahout: {
    skillName: "Mahout",
    explanation:
      "Apache Mahout is a library of scalable machine-learning algorithms, implemented on top of Apache Hadoop and using the MapReduce paradigm.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  lucene: {
    skillName: "Lucene",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  solr: {
    skillName: "Solr",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  avro: {
    skillName: "Avro",
    explanation:
      "Avro provides a convenient way to represent complex data structures within a Hadoop MapReduce job.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  flume: {
    skillName: "Flume",
    explanation:
      "Flume is a distributed, reliable, and available service for efficiently collecting, aggregating, and moving large amounts of log data.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  ambari: {
    skillName: "Ambari",
    explanation:
      "The Apache Ambari project is aimed at making Hadoop management simpler by developing software for provisioning, managing, and monitoring Apache Hadoop clusters.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  impala: {
    skillName: "Impala",
    explanation:
      "Cloudera Impala is the industry’s leading massively parallel processing (MPP) SQL query engine that runs natively in Apache Hadoop.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  drill: {
    skillName: "Drill",
    explanation:
      "Apache Drill is a schema-free SQL query engine for data exploration.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  tez: {
    skillName: "Tez",
    explanation:
      "Tez allows Hive and Pig jobs to be written with fewer MapReduce jobs, which makes Hive and Pig scripts run faster.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  zeppelin: {
    skillName: "Zeppelin",
    explanation:
      "Zeppelin is a Web-based notebook for interactive data analytics. It makes data visualization as easy as drag and drop.",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  nagios: {
    skillName: "Nagios",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  nginx: {
    skillName: "Nginx",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  splunk: {
    skillName: "Splunk",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  rackspace: {
    skillName: "Rackspace",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "google cloud": {
    skillName: "Google Cloud",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Cloud",
    booleanSynonyms: []
  },
  jira: {
    skillName: "JIRA",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  perl: {
    skillName: "Perl",
    explanation: "",
    primaryFamily: "Scripting",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  shell: {
    skillName: "Shell",
    explanation: "",
    primaryFamily: "Scripting",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  bash: {
    skillName: "Bash",
    explanation: "",
    primaryFamily: "Scripting",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  cloudwatch: {
    skillName: "Cloudwatch",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  scala: {
    skillName: "Scala",
    explanation: "",
    primaryFamily: "BigData",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  golang: {
    skillName: "GoLang",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  redis: {
    skillName: "Redis",
    explanation: "",
    primaryFamily: "",
    secondaryFamily: [""],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  storage: {
    skillName: "Storage",
    explanation:
      "The overall set of hardware and software components needed to facilitate storage for a system.",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: ["Cloud", "Data center", "Hitachi", "SAN", "NAS", "EMC", "Etc"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  cloud: {
    skillName: "Cloud",
    explanation:
      "The overall set of hardware and software components needed to facilitate storage for a system.",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: [
      "AWS",
      `"Amazon webservice"`,
      `"Amazon web service"`,
      "EC2",
      "Azure",
      "Iaas",
      "Cloud",
      "Cloudfoundry",
      `"Cloud foundry"`,
      "GCP"
    ],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "data center": {
    skillName: "Storage",
    explanation:
      "The overall set of hardware and software components needed to facilitate storage for a system.",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: ["Cloud", "Data center", "Hitachi", "SAN", "NAS", "EMC", "Etc"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  hitachi: {
    skillName: "Storage",
    explanation:
      "The overall set of hardware and software components needed to facilitate storage for a system.",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: ["Cloud", "Data center", "Hitachi", "SAN", "NAS", "EMC", "Etc"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  san: {
    skillName: "Storage",
    explanation:
      "The overall set of hardware and software components needed to facilitate storage for a system.",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: ["Cloud", "Data center", "Hitachi", "SAN", "NAS", "EMC", "Etc"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  nas: {
    skillName: "Storage",
    explanation:
      "The overall set of hardware and software components needed to facilitate storage for a system.",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: ["Cloud", "Data center", "Hitachi", "SAN", "NAS", "EMC", "Etc"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  emc: {
    skillName: "Storage",
    explanation:
      "The overall set of hardware and software components needed to facilitate storage for a system.",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: ["Cloud", "Data center", "Hitachi", "SAN", "NAS", "EMC", "Etc"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  etc: {
    skillName: "Storage",
    explanation:
      "The overall set of hardware and software components needed to facilitate storage for a system.",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: ["Cloud", "Data center", "Hitachi", "SAN", "NAS", "EMC", "Etc"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  virtualization: {
    skillName: "Virtualization",
    explanation:
      "is the creation of a virtual version of something like operating system",
    primaryFamily: "a server",
    secondaryFamily: ["a storage device or network resources"],
    synonyms: ["Infrastructure"],
    versions: [],
    similarTech: [
      "Vmware",
      "Vsphere",
      "Kernel (KVM)",
      "Xen",
      "XenDesktop",
      "Etc"
    ],
    type: "",
    booleanSynonyms: []
  },
  infrastructure: {
    skillName: "Virtualization",
    explanation:
      "is the creation of a virtual version of something like operating system",
    primaryFamily: "a server",
    secondaryFamily: ["a storage device or network resources"],
    synonyms: ["Infrastructure"],
    versions: [],
    similarTech: [
      "Vmware",
      "Vsphere",
      "Kernel (KVM)",
      "Xen",
      "XenDesktop",
      "Etc"
    ],
    type: "",
    booleanSynonyms: []
  },
  networking: {
    skillName: "Networking",
    explanation: "a group of two or more computer systems linked together",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  security: {
    skillName: "Security",
    explanation:
      "is the defense of digital information and IT assets against internal and external , malicious and accidental threats.",
    primaryFamily: "Infrastructure",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  redhat: {
    skillName: "Redhat",
    explanation: "open - source software products provider to an enterprise",
    primaryFamily: "OS",
    secondaryFamily: [],
    synonyms: ["RHEL", "“Red Hat Enterprise Linux”"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  rhel: {
    skillName: "Redhat",
    explanation: "open - source software products provider to an enterprise",
    primaryFamily: "OS",
    secondaryFamily: [],
    synonyms: ["RHEL", "“Red Hat Enterprise Linux”"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "“red hat enterprise linux”": {
    skillName: "Redhat",
    explanation: "open - source software products provider to an enterprise",
    primaryFamily: "OS",
    secondaryFamily: [],
    synonyms: ["RHEL", "“Red Hat Enterprise Linux”"],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  centos: {
    skillName: "CENTOS",
    explanation: "",
    primaryFamily: "OS",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  ubuntu: {
    skillName: "Ubuntu",
    explanation: "an open source operating system",
    primaryFamily: "",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  unix: {
    skillName: "Unix",
    explanation: "Multitasking -Multiuser computer operating systems",
    primaryFamily: "OS",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "",
    booleanSynonyms: []
  },
  "machine learning": {
    skillName: "Machine Learning",
    explanation: "Science of learning from a pattern of events",
    primaryFamily: "Artificial Intelligence",
    secondaryFamily: [],
    synonyms: ["ML"],
    versions: [],
    similarTech: [],
    type: ""
  },
  ml: {
    skillName: "Machine Learning",
    explanation: "Science of learning from a pattern of events",
    primaryFamily: "Artificial Intelligence",
    secondaryFamily: [],
    synonyms: ["ML"],
    versions: [],
    similarTech: [],
    type: ""
  },
  svm: {
    skillName: "SVM",
    explanation:
      "Support vector machines are supervised learning models with associated learning algorithms that analyze data used for classification and regression analysis.",
    primaryFamily: "Machine Learning",
    secondaryFamily: [],
    synonyms: ["support vector machines"],
    versions: [],
    similarTech: [],
    type: "Algorithm"
  },
  "support vector machines": {
    skillName: "SVM",
    explanation:
      "Support vector machines are supervised learning models with associated learning algorithms that analyze data used for classification and regression analysis.",
    primaryFamily: "Machine Learning",
    secondaryFamily: [],
    synonyms: ["support vector machines"],
    versions: [],
    similarTech: [],
    type: "Algorithm"
  },
  "linear regression.": {
    skillName: "Linear Regression.",
    explanation: "Machine learning algo",
    primaryFamily: "Machine Learning",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Algorithm"
  },
  "logistic regression": {
    skillName: "Logistic Regression",
    explanation: "Machine learning algo",
    primaryFamily: "Machine Learning",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Algorithm"
  },
  "neural networks": {
    skillName: "Neural Networks",
    explanation: "Machine learning algo",
    primaryFamily: "Machine Learning",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Algorithm"
  },
  "naïve bayes": {
    skillName: "Naïve Bayes",
    explanation: "Machine learning algo",
    primaryFamily: "Machine Learning",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Algorithm"
  },
  "deep learning": {
    skillName: "Deep learning",
    explanation: "Its part of the Machine Learning family",
    primaryFamily: "Machine Learning",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: [],
    type: "Algorithm"
  },
  nlp: {
    skillName: "NLP",
    explanation:
      "Ability of a computer program to understand human language as it is spoken",
    primaryFamily: "Artificial Intelligence",
    secondaryFamily: [],
    synonyms: ["Natural language processing", "neuro linguistic programming"],
    versions: [],
    similarTech: [],
    type: ""
  },
  "natural language processing": {
    skillName: "NLP",
    explanation:
      "Ability of a computer program to understand human language as it is spoken",
    primaryFamily: "Artificial Intelligence",
    secondaryFamily: [],
    synonyms: ["Natural language processing", "neuro linguistic programming"],
    versions: [],
    similarTech: [],
    type: ""
  },
  "neuro linguistic programming": {
    skillName: "NLP",
    explanation:
      "Ability of a computer program to understand human language as it is spoken",
    primaryFamily: "Artificial Intelligence",
    secondaryFamily: [],
    synonyms: ["Natural language processing", "neuro linguistic programming"],
    versions: [],
    similarTech: [],
    type: ""
  },
  nltk: {
    skillName: "NLTK",
    explanation:
      "Ability of a computer program to understand human language as it is spoken",
    primaryFamily: "NLP",
    secondaryFamily: [],
    synonyms: [],
    versions: [],
    similarTech: ["Open NLP"],
    type: "Library"
  },
  "open nlp": {
    skillName: "Open NLP",
    explanation:
      "Ability of a computer program to understand human language as it is spoken",
    primaryFamily: "NLP",
    secondaryFamily: [],
    synonyms: ["OpenNLP"],
    versions: [],
    similarTech: [],
    type: ""
  },
  opennlp: {
    skillName: "Open NLP",
    explanation:
      "Ability of a computer program to understand human language as it is spoken",
    primaryFamily: "NLP",
    secondaryFamily: [],
    synonyms: ["OpenNLP"],
    versions: [],
    similarTech: [],
    type: ""
  }
};
export default dictionary;
